module.exports = __webpack_public_path__ + "img/mobile-28.9d60ee64.png";